import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';

export interface NotificacaoViewDTO {
  id?: number,
  type?: any,
  sender?: string,
  title?: string,
  status?: number,
  date?: string,
  read?: number,
  attachments?: number,
  [key: string]: any
}

@Injectable()
export class NotificacoesProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  // getHome(params = {}): Promise<any> {
  //   var me=this;
  //   this.header=APIService.getHeader();

  //   return new Promise((resolve, reject) => {
  //     let uri = new URL(APIService.API_URL + 'notificacoes');

  //     Object.keys(params).forEach(key => {
  //       uri.searchParams.append(key, params[key]);
  //     });

  //     me.http.get(uri.toString(), {headers: this.header}).subscribe((result: any) => {
  //       resolve(result);
  //     },
  //     (error) => {
  //       reject(error);
  //     });
  //   });
  // }

  getSearchHome(termo: string): Promise<any> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let uri = new URL(APIService.API_URL + 'notificacoes?operacao=search');


      me.http.get(uri.toString(), {headers: this.header, params: {
        termo
      }}).subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }

  getPopupBoasVindas(): Promise<{item: any, status_ret: string, erro: string}>
  {
    var me=this;
    me.header=APIService.getHeader();
    return new Promise((resolve, reject) => {

    let url='';
    url = APIService.API_URL + 'notificacoes?operacao=popupboasvindas'
    
    this.http.get(url,{headers:me.header})
      .subscribe((result: any) => {
        var jsonData=result;
        if (jsonData.length!=0)
        {
            var data={
              "item": jsonData,
              "status_ret": "OK",
              "erro": ""
            }
            me.itemret=data;
        }
        else{
          var errodatavazio={
            "item": null,
            'status_ret':'OK',
            'erro':''
          }
          me.itemret=errodatavazio;
        }
        resolve(me.itemret);
      },
      (error) => {
        var errochamada={
          "item": null,
          'status_ret':'NOK',
          'erro':error._body
        }
        me.itemret=errochamada;
        reject(me.itemret);
        //resolve(me.login);
      });
    });
  
  }

  registrarPopupBoasVindas()
  {
    var me=this;
    me.header=APIService.getHeader();
    return new Promise((resolve, reject) => {

    let url='';
    url = APIService.API_URL + 'notificacoes?operacao=popupboasvindas'
    
    this.http.post(url, {}, {headers:me.header})
      .subscribe((result: any) => {
        resolve(result);
      },
      (error) => {
        reject(error);
        //resolve(me.login);
      });
    });
  }


  registrarPostFirebase(deviceId, username){
    var me=this;
    me.header=APIService.getHeader();
    return new Promise((resolve, reject) => {

    let url='';
    url = APIService.NOTIF_URI + 'registerfirebase';
    
    var data = {
      "username":username,
      "handle": deviceId
    };

    var requestData=JSON.stringify(data);
    // //console.log(url);
    // //console.log(requestData);

    this.http.post(url,requestData,{headers:me.header})
      .subscribe((result: any) => {
        //console.log("RESULTADO POST");
        //console.log(result);
        var jsonData=result;
        if (jsonData.length!=0)
        {
            var data={
              "item": jsonData,
              "status_ret": "NOK",
              "erro": ""
            }
            me.itemret=data;
        }
        else{
          var errodatavazio={
            "item": null,
            'status_ret':'NOK',
            'erro':'Erro na geração da chave.'
          }
          me.itemret=errodatavazio;
        }
        resolve(me.itemret);
      },
      (error) => {
        //console.log("ERRO REGISTRO POST");
        //console.log(error);
        
        var errochamada={
          "item": null,
          'status_ret':'NOK',
          'erro':error._body
        }
        me.itemret=errochamada;
        reject(me.itemret);
        //resolve(me.login);
      });
    });

  }


  registrarPost(deviceId, username){
    var me=this;
    me.header=APIService.getHeader();
    return new Promise((resolve, reject) => {

    let url='';
    url = APIService.NOTIF_URI + 'register?handle=' + deviceId + '&username=' + username;
    
    var data ="";
    /*var data = {
      "id":id,
      "TipoEnfermaria": TipoEnfermaria,
      "Descricao": Descricao,
      "Pavimento": Pavimento,
      "Setor":Setor,
      "SexoOriginal":SexoOriginal,
      "SexoAtual":SexoAtual,
      "Status":Status
    };*/

    var requestData=JSON.stringify(data);
    // //console.log(url);
    // //console.log(requestData);

    this.http.post(url,requestData,{headers:me.header})
      .subscribe((result: any) => {
        //console.log("RESULTADO POST");
        //console.log(result);
        var jsonData=result;
        if (jsonData.length!=0)
        {
            var data={
              "item": jsonData,
              "status_ret": "NOK",
              "erro": ""
            }
            me.itemret=data;
        }
        else{
          var errodatavazio={
            "item": null,
            'status_ret':'NOK',
            'erro':'Erro na geração da chave.'
          }
          me.itemret=errodatavazio;
        }
        resolve(me.itemret);
      },
      (error) => {
        //console.log(`ERRO REGISTRO POST: ${error}`)
        var errochamada={
          "item": null,
          'status_ret':'NOK',
          'erro':error._body
        }
        me.itemret=errochamada;
        reject(me.itemret);
        //resolve(me.login);
      });
    });

  }

  registrarPut(idHub, Platform,UserName, deviceId){
    var me=this;
    me.header=APIService.getHeader();
    return new Promise((resolve, reject) => {

    let url='';
    url = APIService.NOTIF_URI + 'register?id=' + idHub;
    
    var data = {
      "Platform":Platform,
      "UserName": UserName,
      "Handle": deviceId,
      "Tags": []
    };
    data.Tags.push(UserName);

    var requestData=JSON.stringify(data);
    //console.log(url);
    //console.log(requestData);

    this.http.put(url,requestData,{headers:me.header})
      .subscribe((result: any) => {
        //console.log("RESULTADO PUT");
        //console.log(result);
        
        var jsonData=result;
        if (jsonData.length!=0)
        {
            var data={
              "item": jsonData,
              "status_ret": "NOK",
              "erro": ""
            }
            me.itemret=data;
        }
        else{
          var errodatavazio={
            "item": null,
            'status_ret':'NOK',
            'erro':'Erro no cadastro do usuário na notificacão.'
          }
          me.itemret=errodatavazio;
        }
        resolve(me.itemret);
      },
      (error) => {
        //console.log('ERRO REGISTRO PUT')
        //console.log(error);
        
        var errochamada={
          "item": null,
          'status_ret':'NOK',
          'erro':error._body
        }
        me.itemret=errochamada;
        reject(me.itemret);
        //resolve(me.login);
      });
    });

  }


  get(usuario){
    var me=this;
    me.header=APIService.getHeader();
    return new Promise((resolve, reject) => {

    let url='';
    url = APIService.NOTIF_URI + 'notification?usuario=' + usuario;
    
    this.http.get(url,{headers:me.header})
      .subscribe((result: any) => {
        var jsonData=result;
        if (jsonData.length!=0)
        {
            var data={
              "item": jsonData,
              "status_ret": "OK",
              "erro": ""
            }
            me.itemret=data;
        }
        else{
          var errodatavazio={
            "item": null,
            'status_ret':'OK',
            'erro':''
          }
          me.itemret=errodatavazio;
        }
        resolve(me.itemret);
      },
      (error) => {
        var errochamada={
          "item": null,
          'status_ret':'NOK',
          'erro':error._body
        }
        me.itemret=errochamada;
        reject(me.itemret);
        //resolve(me.login);
      });
    });
  }


  getHome(continuationToken = null, registraAuditoria = false) {
    var me = this;
    me.header = APIService.getHeader();
    return new Promise((resolve, reject) => {

    let url = '';
    url = APIService.API_URL + 'notificacoes'

    if (continuationToken) {
      url += '?continuationToken=' + continuationToken;
    }

    if (registraAuditoria) {
      url += '?auditar=S';
    }
    
    this.http.get(url,{headers:me.header})
      .subscribe((result: any) => {
        var jsonData=result;
        if (jsonData.length!=0)
        {
            var data={
              "item": jsonData,
              "status_ret": "OK",
              "erro": ""
            }
            me.itemret=data;
        }
        else{
          var errodatavazio={
            "item": null,
            'status_ret':'OK',
            'erro':''
          }
          me.itemret=errodatavazio;
        }
        resolve(me.itemret);
      },
      (error) => {
        var errochamada={
          "item": null,
          'status_ret':'NOK',
          'erro':error._body
        }
        me.itemret=errochamada;
        reject(me.itemret);
        //resolve(me.login);
      });
    });
  }
  






}
